import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { PanierProvider } from "./PanierContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <PanierProvider>
      <App />
    </PanierProvider>
  </React.StrictMode>
);
